import { render, staticRenderFns } from "./PointValue.vue?vue&type=template&id=2042a812&scoped=true&"
import script from "./PointValue.vue?vue&type=script&lang=js&"
export * from "./PointValue.vue?vue&type=script&lang=js&"
import style0 from "./PointValue.vue?vue&type=style&index=0&id=2042a812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042a812",
  null
  
)

export default component.exports